import { LocalizationTextOverridesOutputSchema } from "@redotech/redo-storefront-widget-common/localization-text-overrides";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLocalizationTextOverrides = {
  name: "getLocalizationTextOverrides" as const,
  input: z.object({
    teamId: zExt.objectId(),
    localizationGroupId: zExt.objectId(),
  }),
  output: LocalizationTextOverridesOutputSchema,
};
